import RIOSidebar from '@rio-cloud/rio-uikit/Sidebar';
import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { useAppContext } from '../../layout/AppContext.ts';

type SidebarProps = {
    isOpen: boolean;
    children?: ReactNode;
    onClose?: () => void;
    title?: string;
};

export const Sidebar = ({ isOpen, children, onClose, title }: SidebarProps) => {
    const { sidebarRef } = useAppContext();

    if (!sidebarRef?.current) {
        return null;
    }

    return createPortal(
        <RIOSidebar
            title={title}
            closed={!isOpen}
            onClose={onClose}
            position={RIOSidebar.RIGHT}
            resizable
            minWidth={360}
            width={520}
            maxWidth={820}
            switchModeBreakpoint={1100}
        >
            {children}
        </RIOSidebar>,
        sidebarRef.current
    );
};
